import coraLogo from "./../assets/img/cora-logo.svg";

const Header = () => {
  return (
    <div className="app-header">
      <div className="app-header-logo">
        <a href="https://coraphysicaltherapy.com">
          <img src={coraLogo} alt="CORA Logo" id="app-logo" />
        </a>
      </div>
    </div>
  );
};

export default Header;
